/**
 *  Product List
 */

 const products= [
  {
    id: 0,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/1.jpg",
      "scarves/1.jpg",
    ],
    stock: 32,
    //price: 3500,
    // "discount": 1000,
    //salePrice: 2500,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
  {
    id: 1,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/2.jpg",
      "scarves/2.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
   {
    id: 2,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/3.jpg",
      "scarves/3.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
  {
    id: 3,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/4.jpg",
      "scarves/4.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
  {
    id: 4,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/5.jpg",
      "scarves/5.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
  {
    id: 5,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/6.jpg",
      "scarves/6.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
   {
    id: 6,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/7.jpg",
      "scarves/7.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
  {
    id: 7,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/8.jpg",
      "scarves/8.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
  {
    id: 8,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/9.jpg",
      "scarves/9.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
   {
    id: 9,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/10.jpg",
      "scarves/10.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
   {
    id: 10,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/11.jpg",
      "scarves/11.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
   {
    id: 11,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/12.jpg",
      "scarves/12.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
     {
    id: 12,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/13.jpg",
      "scarves/13.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
    {
    id: 13,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/14.jpg",
      "scarves/14.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
    {
    id: 14,
    artNo: "1000-0047",
    name: "Football Scarf",
    slug: "1a",
    pictures: [
      "scarves/15.jpg",
      "scarves/15.jpg",
    ],
    stock: 32,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
   {
    id: 15,
    artNo: "1000-0047",
    name: "Fan Scarf Marathon",
    slug: "1a",
    pictures: [
      "scarves/fan-scarf-marathon.jpg",
      "scarves/fan-scarf-marathon.jpg",
    ],
    stock: 32,
    //price: 3500,
    // "discount": 1000,
    //salePrice: 2500,
    description:
      "Get your marathon scarf from Wildemasche. Custom knitted with your design and text. Create your runners scarf online. Your favourite text, logo or personal message in a scarf",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Marathon"],
  },
  {
    id: 16,
    artNo: "1000-0048",
    name: "Football Scarf Blue White",
    slug: "2b",
    pictures: [
      "scarves/football-scarf-blue-white.jpg",
      "scarves/football-scarf-blue-white.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in blue and white. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Scarves"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Blue & White"],
  },
  {
    id: 17,
    artNo: "1000-0049",
    name: "Football Scarf Darts",
    slug: "3c",
    pictures: [
      "scarves/football-scarf-darts.jpg",
      "scarves/football-scarf-darts.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "The bundesliga is the major football / soccer league in Germany. Design your football scarf with custom design, made to order with you team name and logo.",
    rating: 5,
    tags: ["Scarves"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Red"],
  },
  {
    id: 18,
    artNo: "1000-0050",
    name: "Football Scarf Leather",
    slug: "4d",
    pictures: [
      "scarves/football-scarf-leather.jpg",
      "scarves/football-scarf-leather.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "The first football you can wear around your neck. Customize and order online now.",
    rating: 5,
    tags: ["Scarves"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Leather"],
  },
  {
    id: 19,
    artNo: "1000-0051",
    name: "Football Scarf Europe",
    slug: "5e",
    pictures: [
      "scarves/football-scarf-europe.jpg",
      "scarves/football-scarf-europe.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Custom football for the old world: Europe is calling, the blue background with the yellow stars of the founding members of the European Union. No minimum order required, scarf is knitted from one single piece with custom design.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Europe"],
  },
  {
    id: 20,
    artNo: "1000-0052",
    name: "Football Scarf Christmas",
    slug: "6f",
    pictures: [
      "scarves/football-scarf-christmas.jpg",
      "scarves/football-scarf-christmas.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Custom football christmas scarf santa would be proud of: the perfect gift for fans. Just add your FC, united or city logo, and off you go in christmas or team colors. Woolen soccer scarves to warm your neck in winter, as birthday gift or present for fellow supporters. Have yours personalized and knitted today.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Christmas"],
  },

  {
    id: 21,
    artNo: "1000-0055",
    name: "Football Scarf Red Black",
    slug: "9i",
    pictures: [
      "scarves/football-scarf-red-black.jpg",
      "scarves/football-scarf-red-black.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in red and black. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Red & Black"],
  },
  {
    id: 22,
    artNo: "1000-0056",
    slug: "10j",
    name: "Football Scarf White Blue",
    pictures: [
      "scarves/football-scarf-white-blue.jpg",
      "scarves/football-scarf-white-blue.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in blue and white. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["White & Blue"],
  },
  {
    id: 23,
    artNo: "1000-0057",
    name: "Football Scarf Dark Blue White",
    slug: "11k",
    pictures: [
      "scarves/footall-scarf-white-dark-blue.jpg",
      "scarves/footall-scarf-white-dark-blue.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in dark blue and white. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Dark Blue & White"],
  },
  {
    id: 24,
    artNo: "1000-0058",
    name: "Football Scarf Yellow Red",
    slug: "12l",
    pictures: [
      "scarves/football-scarf-yellow-red.jpg",
      "scarves/football-scarf-yellow-red.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in yellow and red. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Yellow & Red"],
  },
  {
    id: 25,
    artNo: "1000-0053",
    name: "Football Scarf Black White",
    slug: "7g",
    pictures: [
      "scarves/football-scarf-white-black.jpg",
      "scarves/football-scarf-white-black.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in black and white. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Black & White"],
  },
  {
    id: 26,
    artNo: "1000-0054",
    name: "Football Scarf Blue Yellow",
    slug: "8h",
    pictures: [
      "scarves/football-scarf-blue-yellow.jpg",
      "scarves/football-scarf-blue-yellow.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in blue and yellow. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Blue & Yellow"],
  },
  {
    id: 27,
    artNo: "1000-0055",
    name: "Football Scarf Black Amber",
    slug: "8h",
    pictures: [
      "scarves/Back-Amber.jpg",
      "scarves/Back-Amber.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Black Amber. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Black & Amber"],
  },

  {
    id: 28,
    artNo: "1000-0056",
    name: "Football Scarf Black Red",
    slug: "8h",
    pictures: [
      "scarves/Black-Red.jpg",
      "scarves/Black-Red.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Black Red. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Black Red"],
  },
  {
    id: 29,
    artNo: "1000-0057",
    name: "Football Scarf Black White",
    slug: "8h",
    pictures: [
      "scarves/Black-White.jpg",
      "scarves/Black-White.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Black White. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Black & White"],
  },
  {
    id: 30,
    artNo: "1000-0058",
    name: "Football Scarf Black Yellow",
    slug: "8h",
    pictures: [
      "scarves/Black-Yellow.jpg",
      "scarves/Black-Yellow.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Black Yellow. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Black & Yellow"],
  },
  {
    id: 31,
    artNo: "1000-0059",
    name: "Football Scarf Green White",
    slug: "8h",
    pictures: [
      "scarves/Green-White.jpg",
      "scarves/Green-White.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Green White. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Green & White"],
  },
  {
    id: 32,
    artNo: "1000-0060",
    name: "Football Scarf Navy Sky",
    slug: "8h",
    pictures: [
      "scarves/Navy-Sky.jpg",
      "scarves/Navy-Sky.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Navy Sky. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Navy & Sky"],
  },
  {
    id: 33,
    artNo: "1000-0061",
    name: "Football Scarf Navy White",
    slug: "8h",
    pictures: [
      "scarves/Navy-White.jpg",
      "scarves/Navy-White.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Navy White. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Navy & White"],
  },
  {
    id: 34,
    artNo: "1000-0062",
    name: "Football Scarf Navy Yellow",
    slug: "8h",
    pictures: [
      "scarves/Navy-Yellow.jpg",
      "scarves/Navy-Yellow.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Navy Yellow. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Navy & Yellow"],
  },
  {
    id: 35,
    artNo: "1000-0063",
    name: "Football Scarf Red White",
    slug: "8h",
    pictures: [
      "scarves/Red-White.jpg",
      "scarves/Red-White.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Red White. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Red & White"],
  },
  {
    id: 36,
    artNo: "1000-0064",
    name: "Football Scarf Royal White",
    slug: "8h",
    pictures: [
      "scarves/Royal-White.jpg",
      "scarves/Royal-White.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Royal White. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Royal & White"],
  },
  {
    id: 37,
    artNo: "1000-0065",
    name: "Football Scarf Royal Yellow",
    slug: "8h",
    pictures: [
      "scarves/Royal-Yellow.jpg",
      "scarves/Royal-Yellow.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football scarf with half/half design. The custom scarf for your team in Royal Yellow. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Royal & Yellow"],
  },
  {
    id: 38,
    artNo: "1000-0066",
    name: "Football Argentina Scarf",
    slug: "8h",
    pictures: [
      "scarves/argentinascarf.jpg",
      "scarves/argentinascarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Argentina scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Argentina"],
  },
  {
    id: 39,
    artNo: "1000-0067",
    name: "Football Brazil Scarf",
    slug: "8h",
    pictures: [
      "scarves/brazil-scarf.jpg",
      "scarves/brazil-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Brazil scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Brazil"],
  },
  {
    id: 40,
    artNo: "1000-0068",
    name: "Football Costa Rica Scarf",
    slug: "8h",
    pictures: [
      "scarves/costa-rica-scarf.jpg",
      "scarves/costa-rica-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Costa Rica scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Costa Rica"],
  },
  {
    id: 41,
    artNo: "1000-0069",
    name: "Football Croatia Scarf",
    slug: "8h",
    pictures: [
      "scarves/croatiascarf.jpg",
      "scarves/croatiascarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Croatia scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Croatia"],
  },
  {
    id: 42,
    artNo: "1000-0070",
    name: "Football Denmark Scarf",
    slug: "8h",
    pictures: [
      "scarves/denmark_scarf.jpg",
      "scarves/denmark_scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Denmark scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Denmark"],
  },
  {
    id: 43,
    artNo: "1000-0071",
    name: "Football Germany Scarf",
    slug: "8h",
    pictures: [
      "scarves/germany-football-black-jacquard-scarf.jpg",
      "scarves/germany-football-black-jacquard-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Germany scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Germany"],
  },
  {
    id: 44,
    artNo: "1000-0072",
    name: "Football Greece Scarf",
    slug: "8h",
    pictures: [
      "scarves/greecefootballscarf.jpg",
      "scarves/greecefootballscarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Greece scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Greece"],
  },
  {
    id: 45,
    artNo: "1000-0073",
    name: "Football Holland Scarf",
    slug: "8h",
    pictures: [
      "scarves/holland-scarf.jpg",
      "scarves/holland_scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Holland scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Holland"],
  },
  {
    id: 46,
    artNo: "1000-0074",
    name: "Football Ireland Scarf",
    slug: "8h",
    pictures: [
      "scarves/ireland-scarf.jpg",
      "scarves/ireland-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Ireland scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Ireland"],
  },
  {
    id: 47,
    artNo: "1000-0075",
    name: "Football Italy Scarf",
    slug: "8h",
    pictures: [
      "scarves/italy-football-scarf.jpg",
      "scarves/italy-football-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Italy scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Italy"],
  },
  {
    id: 48,
    artNo: "1000-0076",
    name: "Football Japan Scarf",
    slug: "8h",
    pictures: [
      "scarves/japan-jacquard-scarf.jpg",
      "scarves/japan-jacquard-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Japan scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Japan"],
  },
  {
    id: 49,
    artNo: "1000-0077",
    name: "Football Japan Scarf",
    slug: "8h",
    pictures: [
      "scarves/japan-scarf.jpg",
      "scarves/japan-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Japan scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Japan"],
  },
  {
    id: 50,
    artNo: "1000-0078",
    name: "Football Mexico Scarf",
    slug: "8h",
    pictures: [
      "scarves/mexico-team-scarf.jpg",
      "scarves/mexico-team-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Mexico scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Mexico"],
  },
  {
    id: 51,
    artNo: "1000-0079",
    name: "Football Nigera Scarf",
    slug: "8h",
    pictures: [
      "scarves/nigera-team-scarf.jpg",
      "scarves/nigera-team-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Nigera scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Nigera"],
  },
  {
    id: 52,
    artNo: "1000-0080",
    name: "Football Paraguay Scarf",
    slug: "8h",
    pictures: [
      "scarves/paraguayscarf2.jpg",
      "scarves/paraguayscarf2.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Paraguay scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Paraguay"],
  },
  {
    id: 53,
    artNo: "1000-0081",
    name: "Football Poland Scarf",
    slug: "8h",
    pictures: [
      "scarves/poland-scarf.jpg",
      "scarves/poland-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Poland scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Poland"],
  },
  {
    id: 54,
    artNo: "1000-0082",
    name: "Football Portugal Scarf",
    slug: "8h",
    pictures: [
      "scarves/portugal-scarf.jpg",
      "scarves/portugal-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Portugal scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Portugal"],
  },
  {
    id: 55,
    artNo: "1000-0083",
    name: "Football Spain Scarf",
    slug: "8h",
    pictures: [
      "scarves/spainscarf2.jpg",
      "scarves/spainscarf2.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Spain scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Spain"],
  },
  {
    id: 56,
    artNo: "1000-0084",
    name: "Football Ukraine Scarf",
    slug: "8h",
    pictures: [
      "scarves/ukrainescarf.jpg",
      "scarves/ukrainescarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Ukraine scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Ukraine"],
  },
  {
    id: 57,
    artNo: "1000-0085",
    name: "Football Uraguay Jacquard Scarf",
    slug: "8h",
    pictures: [
      "scarves/uruguay-jacquard-scarf.jpg",
      "scarves/uruguay-jacquard-scarf.jpg",
    ],
    stock: 32,
    //price: 3500,
    //discount: 1000,
    //salePrice: 2500,
    description:
      "Football Uraguay Jacquard scarf with half/half design. The custom scarf for your team. Design online and create your custom team scarf today. Design with logo, text, cliparts etc. Design is knitted in.",
    rating: 5,
    tags: ["Women"],
    size: ["M", "XL"],
    category: "Scarves",
    colors: ["Uraguay Jacquard"],
  },

];

export default products;